(() => {

  const breakpoint = window.matchMedia('(max-width: 768px)');
  // const singleSliders = qsa('.js-featured-single-collection-swiper');
  const singleSliders = document.querySelectorAll('.js-featured-single-collection-swiper');

  const initSwiper = (
    init = false,
    slidesOffsetBefore = 100
  ) => {
    singleSliders && singleSliders.forEach((slider, index) => {
      const sectionID = slider.closest('.js-featured-single-collection').dataset.sectionId;
      
      new Swiper(`.js-featured-single-collection-swiper-${sectionID}`, {
        slidesPerView: 'auto',
        init: init,
        slidesOffsetBefore: slidesOffsetBefore,
        freeMode: true,
        navigation: {
          nextEl: `.js-featured-single-collection-button-next-${sectionID}`,
          prevEl: `.js-featured-single-collection-button-prev-${sectionID}`,
          clickable: true
        },
        pagination: {
          el: `.js-featured-single-collection-pagination-${sectionID}`,
          type: 'bullets'
        }
      });
    })
  }

  const breakpointChecker = () => {
    if (breakpoint.matches) {
      initSwiper(true, 0);
    } else {
      initSwiper(true);
    }
  };

  breakpoint.addEventListener('change', breakpointChecker);
  document.addEventListener("shopify:section:load", breakpointChecker);
  breakpointChecker();
})();
